module.exports = __webpack_public_path__ + "static/media/iyzico-setup-step2.7ac5aff0.png";